import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import Icon from './Icon';
import './stylesheets/Ellipsis.scss';

export default function Ellipsis(props) {
  const { onClick, className, disabled } = props;
  const classes = {
    loc: true,
    ellipsis: true,
    disabled
  };

  return (
    <span className={classNames(classes, className)} onClick={onClick}>
      <Icon icon="ellipsis" />
    </span>
  );
}

Ellipsis.propTypes = {
  /** An function triggered onClick */
  onClick: PropTypes.func,
  /** Additional className to customize style */
  className: PropTypes.string,
  /** Flag to use when the ellipsis should not have hover functionality */
  disabled: PropTypes.bool
};

Ellipsis.defaultProps = {
  disabled: false
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/Ellipsis.jsx